"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionCss = void 0;
var utils_1 = require("../../utils/utils");
var SelectionCss = function (target) {
    return /** @class */ (function (_super) {
        __extends(SelectionCss, _super);
        function SelectionCss() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SelectionCss.prototype.render = function () {
            var selection = _super.prototype.render.call(this);
            var selectionCssClass = this.options.get('selectionCssClass') || '';
            if (selectionCssClass.indexOf(':all:') !== -1) {
                selectionCssClass = selectionCssClass.replace(':all:', '');
                utils_1.Utils.copyNonInternalCssClasses(selection, this.core.element);
            }
            selection.classList.add(selectionCssClass);
            return selection;
        };
        return SelectionCss;
    }(target));
};
exports.SelectionCss = SelectionCss;
//# sourceMappingURL=selection-css.js.map